
const searchCollegeDatabase = async (collegeName, database) => {
    // const results = await database.results;

    const foundSchool = database.results.find(result => result["latest.school.name"] === collegeName);
    if (foundSchool) {
        return foundSchool;
    }
    else {
        return "School not found";
    }


}

/**
 * smartSearchCollegeDatabase
 *
 * Wraps the smartSearch engine to look up a single school by name,
 * using fuzzy matching, alias resolution, and relevance ranking.
 *
 * Falls back gracefully to "School not found" when nothing matches.
 *
 * @param {string} collegeName - The name (or alias) the user typed
 * @param {object} database    - The cached API payload { results: [...] }
 * @returns {object|string}    - The best-matching school entry, or "School not found"
 */
const smartSearchCollegeDatabase = async (collegeName, database) => {
    if (!collegeName || !database || !database.results) {
        return "School not found";
    }

    // Inline require so this module stays CommonJS-compatible in tests
    // while the React app uses the ES module import in smartSearch.js
    let smartSearchFn;
    try {
        smartSearchFn = require('./smartSearch').smartSearch;
    } catch {
        // Fallback to exact match if smartSearch cannot be loaded
        return searchCollegeDatabase(collegeName, database);
    }

    const matches = smartSearchFn(collegeName, database.results, { maxResults: 1 });
    if (matches && matches.length > 0) {
        return matches[0];
    }

    return "School not found";
};

module.exports = { searchCollegeDatabase, smartSearchCollegeDatabase };
